import { ErrorPage } from "@src/appV2/Errors/ErrorPage";
import { SupportContext } from "@src/appV2/support/constants";

export function NoSignedAgreementFileAvailable() {
  return (
    <ErrorPage
      title="Oops! We could not locate your agreement"
      supportContext={SupportContext.NO_WORKER_AGREEMENT_FILE_AVAILABLE}
      description="It might take a little while before it shows up here. Please try again in a moment."
    />
  );
}
